import delegate from 'delegate-it';

class FilterNew {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.initUiState();
    this.attachEvents();
    this.submitEvents();
  }

  initUiState() {
    this.uiState = {
      modalVisibility: 'hidden',
      activeOptionsCount: 0,
    };
  }

  attachEvents() {
    delegate(this.rootElement, '[data-entity="modal-toggler"]', 'click', this.togglerClickHandler.bind(this));
  }

  togglerClickHandler() {
    this.uiState.modalVisibility = this.uiState.modalVisibility === 'hidden' ? 'shown' : 'hidden';

    this.renderModal();
  }

  renderModal() {
    this.modal = this.rootElement.querySelector('[data-entity="modal"]');

    if (!this.modal) {
      return;
    }

    const { modalVisibility } = this.uiState;

    if (modalVisibility === 'hidden') {
      this.modal.classList.add('filter-new__modal_hidden');
      this.modal.classList.remove('filter-new__modal_shown');
    }

    if (modalVisibility === 'shown') {
      this.modal.classList.add('filter-new__modal_shown');
      this.modal.classList.remove('filter-new__modal_hidden');
    }
  }

  submitEvents() {
    delegate(this.rootElement, '.filter-new__submit', 'click', this.closeModal.bind(this));
  }

  closeModal() {
    this.modal = this.rootElement.querySelector('[data-entity="modal"]');

    if (!this.modal) {
      return;
    }

    const { modalVisibility } = this.uiState;

    if (modalVisibility === 'shown') {
      this.modal.classList.add('filter-new__modal_hidden');
      this.modal.classList.remove('filter-new__modal_shown');
    }
  }
}

export default FilterNew;
